export const WASABI_SEARCH_INSTITUTIONS_START =
  'WASABI_SEARCH_INSTITUTIONS_START';
export const WASABI_SEARCH_INSTITUTIONS_SUCCESS =
  'WASABI_SEARCH_INSTITUTIONS_SUCCESS';
export const WASABI_SEARCH_INSTITUTIONS_FAILURE =
  'WASABI_SEARCH_INSTITUTIONS_FAILURE';

export const WASABI_FETCH_INSTITUTION_START = 'WASABI_FETCH_INSTITUTION_START';
export const WASABI_FETCH_INSTITUTION_SUCCESS =
  'WASABI_FETCH_INSTITUTION_SUCCESS';
export const WASABI_FETCH_INSTITUTION_FAILURE =
  'WASABI_FETCH_INSTITUTION_FAILURE';

export const WASABI_FETCH_INSTITUTION_COURSES_START =
  'WASABI_FETCH_INSTITUTION_COURSES_START';
export const WASABI_FETCH_INSTITUTION_COURSES_SUCCESS =
  'WASABI_FETCH_INSTITUTION_COURSES_SUCCESS';
export const WASABI_FETCH_INSTITUTION_COURSES_FAILURE =
  'WASABI_FETCH_INSTITUTION_COURSES_FAILURE';

export const WASABI_FETCH_INSTITUTION_USAGE_START =
  'WASABI_FETCH_INSTITUTION_USAGE_START';
export const WASABI_FETCH_INSTITUTION_USAGE_SUCCESS =
  'WASABI_FETCH_INSTITUTION_USAGE_SUCCESS';
export const WASABI_FETCH_INSTITUTION_USAGE_FAILURE =
  'WASABI_FETCH_INSTITUTION_USAGE_FAILURE';

export const WASABI_FETCH_INSTITUTION_MEMBERS_START =
  'WASABI_FETCH_INSTITUTION_MEMBERS_START';
export const WASABI_FETCH_INSTITUTION_MEMBERS_SUCCESS =
  'WASABI_FETCH_INSTITUTION_MEMBERS_SUCCESS';
export const WASABI_FETCH_INSTITUTION_MEMBERS_FAILURE =
  'WASABI_FETCH_INSTITUTION_MEMBERS_FAILURE';

export const WASABI_FETCH_INSTITUTION_IS_ACCREDIBLE_ENABLED_START =
  'WASABI_FETCH_INSTITUTION_IS_ACCREDIBLE_ENABLED_START';
export const WASABI_FETCH_INSTITUTION_IS_ACCREDIBLE_ENABLED_SUCCESS =
  'WASABI_FETCH_INSTITUTION_IS_ACCREDIBLE_ENABLED_SUCCESS';
export const WASABI_FETCH_INSTITUTION_IS_ACCREDIBLE_ENABLED_FAILURE =
  'WASABI_FETCH_INSTITUTION_IS_ACCREDIBLE_ENABLED_FAILURE';

export const WASABI_UPDATE_INSTITUTION_IS_ACCREDIBLE_ENABLED_START =
  'WASABI_UPDATE_INSTITUTION_IS_ACCREDIBLE_ENABLED_START';
export const WASABI_UPDATE_INSTITUTION_IS_ACCREDIBLE_ENABLED_SUCCESS =
  'WASABI_UPDATE_INSTITUTION_IS_ACCREDIBLE_ENABLED_SUCCESS';
export const WASABI_UPDATE_INSTITUTION_IS_ACCREDIBLE_ENABLED_FAILURE =
  'WASABI_UPDATE_INSTITUTION_IS_ACCREDIBLE_ENABLED_FAILURE';

export const WASABI_UPDATE_INSTITUTION_IS_LOW_COST_ENABLED_START =
  'WASABI_UPDATE_INSTITUTION_IS_LOW_COST_ENABLED_START';
export const WASABI_UPDATE_INSTITUTION_IS_LOW_COST_ENABLED_SUCCESS =
  'WASABI_UPDATE_INSTITUTION_IS_LOW_COST_ENABLED_SUCCESS';
export const WASABI_UPDATE_INSTITUTION_IS_LOW_COST_ENABLED_FAILURE =
  'WASABI_UPDATE_INSTITUTION_IS_LOW_COST_ENABLED_FAILURE';

export const WASABI_UPDATE_INSTITUTION_COURSE_KEEP_ALIVE_ENABLED_START =
  'WASABI_UPDATE_INSTITUTION_COURSE_KEEP_ALIVE_ENABLED_START';
export const WASABI_UPDATE_INSTITUTION_COURSE_KEEP_ALIVE_ENABLED_SUCCESS =
  'WASABI_UPDATE_INSTITUTION_COURSE_KEEP_ALIVE_ENABLED_SUCCESS';
export const WASABI_UPDATE_INSTITUTION_COURSE_KEEP_ALIVE_ENABLED_FAILURE =
  'WASABI_UPDATE_INSTITUTION_COURSE_KEEP_ALIVE_ENABLED_FAILURE';
